import React from 'react';
import { Box, Typography, Grid, Link, Button } from '@mui/material';
import Section from '../../../shared/Section/Section';
import Steps from '../../../shared/Steps/Steps';
import styles from './styles';
import AlumniCompanies from '../../AlumniCompanies/AlumniCompanies';

function StudentsWork({ data: { companies, steps, link }, logosData }) {
  return (
    <Section bg="work">
      <Box
        sx={{
          marginBottom: {
            xs: '50px',
            xl: '80px',
          },
        }}
      >
        {companies.title && (
          <Typography variant="desktopH3" sx={styles.titleDifferent}>
            {companies.title}
          </Typography>
        )}

        <AlumniCompanies />
      </Box>

      <Box>
        {steps.title && (
          <Typography variant="desktopH3" sx={styles.title}>
            {steps.title}
          </Typography>
        )}

        <Grid container>
          <Grid item xs={12} xl={11}>
            <Steps {...steps} />
          </Grid>
        </Grid>
      </Box>
      <Link href={link.url} sx={styles.link}>
        <Button
          variant="kitPrimary"
          size="medium"
          component="span"
          tabIndex={-1}
          sx={styles.button}
        >
          {link.title}
        </Button>
      </Link>
    </Section>
  );
}

export default StudentsWork;
